/**
 * Lit la largeur et la hauteur utiles du viewport (préfère visualViewport si disponible).
 * @returns {{ w: number, h: number }} Dimensions en pixels
 */
export const readViewport = () => {
    if (typeof window === "undefined") {
        return {w: 0, h: 0}
    }

    const vv = window.visualViewport
    if (vv) {
        return {w: Math.round(vv.width), h: Math.round(vv.height)}
    }

    return {w: window.innerWidth, h: window.innerHeight}
}

/**
 * Convertit une longueur issue des design tokens (chaîne "4rem", "12px", etc.) en pixels entiers.
 * @param {string|number|null|undefined} value
 * @returns {number}
 */
export const cssLengthToPx = value => {
    if (value == null) {
        return 0
    }

    // Si la valeur est dejà de type Number
    if (typeof value === "number" && Number.isFinite(value)) {
        return Math.round(value)
    }

    // Si la valeur n'est pas de type string
    if (typeof value !== "string") {
        return 0
    }

    const trimmed = value.trim().toLowerCase()

    // Si la valeur est suffixée par "px"
    const pxMatch = trimmed.match(/^(-?[\d.]+)px$/)
    if (pxMatch) {
        return Math.round(Number(pxMatch[1]))
    }

    // Si la valeur est suffixée par "rem"
    const remMatch = trimmed.match(/^(-?[\d.]+)rem$/)
    if (remMatch) {
        // On récupère la font-size, ou alors 16px par defaut
        const rootFontPx =
            typeof document !== "undefined" ? parseFloat(getComputedStyle(document.documentElement).fontSize) || 16 : 16

        return Math.round(Number(remMatch[1]) * rootFontPx)
    }

    // Si la valeur n'a pas de suffixe ("12", ".5")
    const n = Number.parseFloat(trimmed)
    return Number.isFinite(n) ? Math.round(n) : 0
}
